<template>
  <div class="m-magazine">
    <van-nav-bar
      title="我的电子杂志"
      left-arrow
      @click-left="$router.back()"
      fixed
      placeholder
    />

    <!-- 骨架屏加载 -->
    <div v-if="loading" class="m-magazine__skeleton">
      <div v-for="n in 6" :key="n" class="m-magazine__skeleton-item">
        <div class="m-magazine__skeleton-cover"></div>
        <div class="m-magazine__skeleton-name"></div>
      </div>
    </div>

    <div v-else-if="magazineList.length > 0" class="m-magazine__grid">
      <div
        v-for="item in magazineList"
        :key="item.emagazineCode"
        class="m-magazine__item"
      >
        <div class="m-magazine__cover-wrapper">
          <img
            class="m-magazine__cover"
            :src="item.cover"
            :alt="item.name"
            @click="viewMagazine(item)"
          />
          <span v-if="item.isRead === 0" class="m-magazine__badge">NEW</span>
        </div>
        <div class="m-magazine__name">{{ item.name }}</div>
      </div>
    </div>

    <van-empty v-else description="暂无电子杂志" />

    <!-- 阅读器弹层 -->
    <MagazineReader
      v-if="currentEmagazineCode"
      :emagazine-code="currentEmagazineCode"
      :hide-buy="true"
      @close="closeReader"
    />
  </div>
</template>

<script>
import { Toast } from 'vant'
import mobileViewport from './mixins/viewport'
import { getMyMagazineList } from '../../api/magazine'
import MagazineReader from '../magazine/components/MagazineReader.vue'

const PC_VIEWPORT = 'width=804, user-scalable=no'
const MOBILE_VIEWPORT = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'

export default {
  mixins: [mobileViewport],
  name: 'MobileMagazine',
  components: { MagazineReader },
  data() {
    return {
      magazineList: [],
      pageNum: 1,
      pageSize: 12,
      loading: false,
      currentEmagazineCode: ''
    }
  },
  mounted() {
    this.getMagazineList()
    // 登录后返回：如果有购买标记，自动打开对应杂志阅读器
    const buyCode = localStorage.getItem('magazine_buy_code')
    if (buyCode) {
      // 切换到 PC 端 viewport，让 MagazineReader 以 804px 宽度正常显示
      const meta = document.querySelector('meta[name="viewport"]')
      if (meta) meta.setAttribute('content', PC_VIEWPORT)
      this.currentEmagazineCode = buyCode
    }
  },
  methods: {
    async getMagazineList() {
      this.loading = true
      try {
        const res = await getMyMagazineList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        const data = res.data || {}
        this.magazineList = data.records || []
      } catch (err) {
        Toast(err.message || '获取电子杂志列表失败')
      } finally {
        this.loading = false
      }
    },
    viewMagazine(item) {
      // 切换到 PC 端 viewport，让 MagazineReader 以 804px 宽度正常显示
      const meta = document.querySelector('meta[name="viewport"]')
      if (meta) meta.setAttribute('content', PC_VIEWPORT)
      this.currentEmagazineCode = item.emagazineCode
    },
    closeReader() {
      this.currentEmagazineCode = ''
      // 恢复移动端 viewport
      const meta = document.querySelector('meta[name="viewport"]')
      if (meta) meta.setAttribute('content', MOBILE_VIEWPORT)
    },
  }
}
</script>

<style scoped>
.m-magazine {
  min-height: 100vh;
  background: #F5F7FA;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* ====== 骨架屏 ====== */
.m-magazine__skeleton {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 12px;
}

.m-magazine__skeleton-item {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.m-magazine__skeleton-cover {
  width: 100%;
  aspect-ratio: 3 / 4;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

.m-magazine__skeleton-name {
  height: 14px;
  margin: 8px 10px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

.m-magazine__skeleton-actions {
  display: flex;
  gap: 8px;
  padding: 4px 10px 10px;
}

.m-magazine__skeleton-btn {
  flex: 1;
  height: 24px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* ====== 列表 ====== */
.m-magazine__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 12px;
}

.m-magazine__item {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.m-magazine__cover-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  background: #f5f5f5;
}

.m-magazine__cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-magazine__badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #FF4D4F;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
}

.m-magazine__name {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  padding: 8px 10px 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
